<template>
  <div>
    <documents-crud-list title="Formulaires" category="Formulaires" />
  </div>
</template>

<script>
import DocumentsCrudList from './UIComponents/DocumentsCrudList.vue';

export default {
  components: {
    DocumentsCrudList,
  },
};
</script>
